import { OccupancyResponse } from "../../../services/availability-and-rates/response/OccupancyResponse";

export const mapOccCalendar = ({ occupancy }: { occupancy: OccupancyResponse }) => {
    return Object.entries(occupancy.data).map(([date, data]) => ({
        date,
        total_rooms: data.total_rooms,
        total_booked: data.total_booked.toString(),
        occupancy: data.occupancy
    }));
};